// src/data/sampleQuestions.js

// A sample question is either:
//   - a string: clicking the chip sends it as a message, or
//   - an object { label, action, placeholder }: clicking the chip runs `action`
//     instead of sending. The only action today is "focus", which focuses the
//     chat input and swaps in `placeholder`.
export const SAMPLE_QUESTIONS = [
  "What is the best way to guide an associate whose speed is affecting the quality of their customer interactions?",
  "How can I help an associate who struggled to handle an extremely challenging customer call?",
  "How do I provide constructive feedback to an associate whose overly friendly approach is blurring professional boundaries?",
  "How can I support an associate in improving their emotional connection with customers despite strong technical performance?",
  "What is the most effective way to address an associate's difficulties in adapting to new technology?",
  {
    label: "Review a contact transcript",
    action: "focus",
    placeholder:
      "Paste the customer and CSA conversation here. You can add context like the contact type or what you want feedback on.",
    // Sent to the model with the pasted transcript appended, while the chat
    // bubble shows only what the manager actually pasted. Ends with
    // "Transcript:" because the transcript follows it directly.
    promptPrefix: `You are reviewing a customer service chat transcript on behalf of the associate's Team Manager. Evaluate the Customer Service Associate (CSA), not the customer and not the bot. Do not role-play.

Return exactly these sections:
1. Verdict: one line, Good contact or Needs coaching.
2. Competencies demonstrated: bullet list, each with a short quote from the transcript as evidence.
3. Gaps / opportunities: bullet list, each with a short quote as evidence.
4. Coaching conversation starter: 2-3 lines the Team Manager can use with this CSA (SBI format).

Transcript:`,
  },
];

// Shown one at a time while a response is in flight. Responses can take 20-45
// seconds, so these advance in order and hold on the last one rather than
// looping back to the beginning.
export const LOADING_MESSAGES = [
  "Reading your message...",
  "Checking against the knowledge base...",
  "Putting the response together...",
];
